// extracted by mini-css-extract-plugin
export default {"imageBox":"edit_imageBox__U8ZJO","placeholder":"edit_placeholder__gzthe"};